// Every list the app loads from the server, in one table. A row says what to ask for and when:
//   key   the name a screen reads it by (data.<key>)
//   path  where it comes from
//   mode  "list" (default) or "object": how the answer is unpacked
//   page  the page whose grant is needed to read it; without that grant the request is not sent at all
//   live  needed by the frame or the home page: loaded with the app and kept fresh by every full reload
//   poll  also re-read every 30 seconds while the tab is open
// A resource that is not live is loaded when a page that needs it is opened: that page names it in `needs` in
// Platform/routes.jsx, and routeNeeds.test.js fails if a page reads a resource it neither needs nor gets live.
// A key nobody reads is a request for nothing, so resources.test.js fails for one. Add a row when a screen needs data.
export const RESOURCES = [
  { key: "me", path: "/Users/Auth/Me/", mode: "object", live: true, poll: true },
  { key: "employees", path: "/Users/EmployeeProfiles/?page_size=1000", live: true },
  { key: "departments", path: "/Users/Departments/?page_size=1000" },
  { key: "positions", path: "/Users/Positions/" },
  { key: "payProfiles", path: "/Users/PayProfiles/", page: "finance" },
  { key: "bankAccounts", path: "/Users/EmployeeBankAccounts/" },
  { key: "projects", path: "/Project/ProjectWorkspaces/", page: "project_management", live: true },
  { key: "teamAssignments", path: "/Project/TeamAssignments/", page: "project_management" },
  { key: "tasks", path: "/TasksDashboard/WorkItems/", live: true, poll: true },
  { key: "dailyStatus", path: "/TasksDashboard/DailyStatusEntries/", live: true, poll: true },
  { key: "notifications", path: "/MainApp/Notifications/", live: true, poll: true },
  { key: "leaveRequests", path: "/MainApp/LeaveRequests/", live: true },
  { key: "leaveOverview", path: "/MainApp/leave/", mode: "object" },
  { key: "leadTags", path: "/Banao/LeadTags/" },
  { key: "lmsLeads", path: "/Lms/api/leads/?limit=1", mode: "object" },
  { key: "delays", path: "/Project/ProjectDelays/", page: "delay_management", live: true },
  { key: "genericHtmlTemplates", path: "/HtmlTemplate/GenericHtmlTemplates/", page: "send_certificate" },
  { key: "agentPrincipals", path: "/McpAccessLayer/AgentPrincipals/" },
  { key: "mcpToolDefinitions", path: "/McpAccessLayer/McpToolDefinitions/" },
  { key: "mcpResourceDefinitions", path: "/McpAccessLayer/McpResourceDefinitions/" },
  { key: "mcpAccessGrants", path: "/McpAccessLayer/McpAccessGrants/" },
  { key: "mcpInvocationAudits", path: "/McpAccessLayer/McpInvocationAudits/" },
  { key: "draftAgentActions", path: "/McpAccessLayer/DraftAgentActions/" },
];

// Lists the server answer is split into on arrival (see applyPayload): a page reading one of these needs the resource
// they come from.
export const DERIVED_FROM = { activeDepartments: "departments", leadRows: "lmsLeads", leadOriginCounts: "lmsLeads" };

export const LIVE_KEYS = RESOURCES.filter((r) => r.live).map((r) => r.key);
export const POLL_KEYS = RESOURCES.filter((r) => r.poll).map((r) => r.key);
